import {
  GET_PRIMEUR_HEADER,
  GET_PRIMEUR_LIVE,
  GET_PRIMEUR_RECAP,
  GET_PRIMEUR_PREPA
} from '../constants/primeur';

import {
  fetchPrimeurHeader,
  fetchPrimeurLive,
  fetchPrimeurRecap,
  fetchPrimeurPrepa
} from '../api/primeur';

export const getPrimeurHeader = () => async (dispatch) => {
  const headerData = await fetchPrimeurHeader();
  dispatch({
    type: GET_PRIMEUR_HEADER,
    payload: headerData
  });
};

export const getPrimeurLive = (options) => async (dispatch) => {
  const data = await fetchPrimeurLive(options);
  dispatch({
    type: GET_PRIMEUR_LIVE,
    payload: data
  });
};
export const getPrimeurRecap = (vintage) => async (dispatch) => {
  const data = await fetchPrimeurRecap(vintage);
  dispatch({
    type: GET_PRIMEUR_RECAP,
    payload: data
  });
};

export const getPrimeurPrepa = () => async (dispatch) => {
  const data = await fetchPrimeurPrepa();
  dispatch({
    type: GET_PRIMEUR_PREPA,
    payload: data
  });
};
